import { t } from "ttag";

export const DEFAULT_DEBOUNCE_TIME = 300;

export const VARIANT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  QUATERNARY: "quaternary",
  QUINARY: "quinary",
} as const;

export const SIZE = {
  X_SMALL: "xs",
  SMALL: "sm",
  MEDIUM: "md",
  LARGE: "lg",
  X_LARGE: "xl",
} as const;

export const PERIOD = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
} as const;

export const FIELD_TYPE = {
  CHECKBOX: "checkbox",
  DROPDOWN: "dropdown",
  HORIZONTAL_RADIO: "horizontal_radio",
  RADIO: "radio",
  READ_ONLY: "read_only",
  READ_ONLY_LINK: "read_only_link",
  TEXT: "text",
  TEXTAREA: "textarea",
  FILE: "document_upload",
  HIDDEN: "hidden",
  NUMBER: "number",
} as const;

export const NOW = new Date();

export const CONSULTATION_PURPOSE = {
  REFILL: "refill",
  CONSULTATION: "consultation",
} as const;

// The BE is supposedly receiving up to 5 MB
// but it's not working properly, so we're going to reduce it to 4 MB.
export const MAX_UPLOAD_SIZE = 1024 * 1024 * 4; // 4MB
export const MAX_UPLOAD_SIZE_PLACEHOLDER = t`Maximum size: 4MB`;
export const HEALTHIE_FILE_STALE_TIME = 9000;

export const IMAGE_FILE_TYPES = {
  PNG: "image/png" as Blob["type"],
  JPEG: "image/jpeg" as Blob["type"],
  PDF: "application/pdf" as Blob["type"],
} as const;

export const ACCEPT_IMAGE_FILE = {
  [IMAGE_FILE_TYPES.PNG]: [],
  [IMAGE_FILE_TYPES.JPEG]: [],
  [IMAGE_FILE_TYPES.PDF]: [],
};

export const ACCEPTED_IMAGE_TYPES: Blob["type"][] =
  Object.keys(ACCEPT_IMAGE_FILE);

export const COACHING_SESSION_TYPE = {
  NUTRITIONAL: "nutritional",
  MINDSET: "mindset",
  MOVEMENT: "movement",
  SPANISH: "spanish",
} as const;

export const PROVIDER_FOLDER = {
  ...COACHING_SESSION_TYPE,
  LEVELS_RX_RESOURCES: "levels-rx-resources",
} as const;

export const READ_ONLY_DOCUMENT_FOLDER = {
  ...PROVIDER_FOLDER,
  DOCTOR_NOTES: "doctor-notes",
} as const;

export const DOCUMENT_FOLDER = {
  LABS: "labs",
  PRESCRIPTIONS: "prescriptions",
  OTHER: "other",
} as const;

export const PROVIDER_PREFERENCE = {
  CUSTOM: "custom",
  EARLIEST: "earliest",
} as const;
